import React from "react";

export default function AdhanDeveloper() {
  return (
    <div className="w-full md:h-lvh bg-black flex items-center justify-center">
      <div className="max-w-[1200px]">
        <h3 className="text-center text-3xl font-bold text-white py-4 pb-20">
          Know the developer
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 items-center gap-20 ">
          <div>
            <img
              className="rounded-full w-[200px] flex"
              src="/asset/profile/kashif-img.jpeg"
              alt="Kashif"
            />
            <h4 className="text-center text-white text-2xl">Kashif</h4>
            <div className="flex items-center justify-evenly">
              <a
                className="text-blue-200"
                href="https://github.com/MirzaKashifBaig"
              >
                Github
              </a>
              <a className="text-blue-200" href="https://twitter.com/mmkbaig">
                X
              </a>
            </div>
          </div>
          <div>
            <img
              className="rounded-full w-[200px] flex"
              src="/asset/profile/haaris-img.jpeg"
              alt="Haaris Iqubal"
            />
            <h4 className="text-center text-white text-2xl">Haaris</h4>
            <div className="flex items-center justify-evenly">
              <a
                className="text-blue-200"
                href="https://github.com/haarisiqubal"
              >
                Github
              </a>
              <a
                className="text-blue-200"
                href="https://twitter.com/haaris_iqubal"
              >
                X
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
